function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "b1irxm8jsa",
  d: "M5.391 15.667V9.992l6.194 4.408c.123.087.27.131.415.131.146 0 .291-.044.415-.131l6.194-4.408v5.675H5.39zm11.81-6.334L12 13.034l-5.2-3.7h10.4zm2.797-.68c0-.026-.004-.05-.007-.075-.003-.019-.004-.038-.009-.057-.005-.021-.013-.042-.02-.063-.007-.02-.013-.042-.023-.062-.008-.017-.019-.033-.028-.05-.013-.022-.025-.044-.04-.064l-.008-.013c-.01-.012-.021-.021-.032-.033-.016-.018-.032-.036-.05-.053-.016-.015-.034-.027-.052-.04-.018-.014-.035-.027-.054-.039l-.06-.031-.06-.027c-.022-.008-.044-.013-.067-.02l-.062-.014c-.026-.005-.052-.006-.077-.008-.015 0-.03-.004-.045-.004H4.696c-.016 0-.03.003-.045.004-.026.002-.051.004-.076.008-.022.003-.043.01-.064.015-.022.006-.044.011-.066.02-.02.007-.04.016-.06.026l-.06.031c-.02.012-.036.025-.054.038-.018.014-.036.026-.052.042-.018.016-.034.034-.05.052-.01.012-.022.021-.032.033l-.008.013c-.015.02-.027.042-.04.064-.01.017-.02.033-.028.05-.01.02-.016.041-.023.062-.007.021-.015.042-.02.063-.005.019-.006.038-.009.057-.003.025-.007.05-.007.074L4 8.667v7.666c0 .369.311.667.696.667h14.608c.385 0 .696-.299.696-.667V8.667l-.002-.015z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-48 -204) translate(32 184) translate(16 20)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "47frlksycb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b1irxm8jsa"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#b1irxm8jsa"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#47frlksycb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "matrix(1 0 0 -1 0 24)"
}))))));

function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.170ce3d7.svg";
export { ForwardRef as ReactComponent };